import { useMutation, useQuery } from "react-query"

import { EStatusType, ETankStackKeys } from "@letshang/constants"
import { ApiInputMap } from "@letshang/firebase-services"
import { useRecoilState } from "recoil"

import { guestListState } from "@fuse/recoil/events"

import {
  approveApplicant,
  disapproveApplicant,
  fetchGuestListForEvent,
  fetchInvitedListForEvent,
  fetchMessageRecordForEvent,
  scanTicket,
} from "@api/firebaseWrappedApis"

export const useGuestListData = (
  eventId: string,
  invitedId?: string,
  deepLink?: string,
) => {
  const [guestListRecoil, setGuestListRecoil] = useRecoilState(guestListState)
  const {
    data: guestList,
    refetch: refetchGuestList,
    isLoading: isGuestListLoading,
  } = useQuery(
    [ETankStackKeys.EVENT_MEMBER_LIST, eventId],
    async () => {
      try {
        const res = await fetchGuestListForEvent({ eventId: eventId })
        setGuestListRecoil((prev) => ({
          ...prev,
          isLoading: false,
          guestList: res.data,
        }))
        return res.data
      } catch (error) {
        console.error("Failed to fetch invited list data:", error)
      }
    },
    {
      onSettled: () => {},
    },
  )

  const {
    data: invitedListData,
    refetch: refetchInvitedListData,
    isLoading: isInvitedListLoading,
  } = useQuery(["invitedList", eventId], async () => {
    try {
      const res = await fetchInvitedListForEvent({ eventId: eventId })
      const data = res.data.filter(
        (guest) =>
          guest.status !== EStatusType.Accepted &&
          guest.status !== EStatusType.Declined &&
          guest.status !== EStatusType.User_Declined,
      )

      return data
    } catch (error) {
      console.error("Failed to fetch invited list data:", error)
    }
  })

  const {
    data: messageRecords,
    refetch: refetchMessageRecords,
    isLoading: isMessageRecordsLoading,
  } = useQuery(["messageRecords", eventId], async () => {
    try {
      const res = await fetchMessageRecordForEvent({ eventId: eventId })
      const result = res.data.filter((record) =>
        record.sentTo.startsWith("whatsapp:"),
      )
      return result
    } catch (error) {
      console.error("Failed to message records data:", error)
    }
  })

  const approveApplicantCall = async (payload: {
    eventId: string
    ticketId: string
    applicantUid: string
  }) => {
    const res = await approveApplicant(payload)
    return res
  }

  const disapproveApplicantCall = async (payload: {
    eventId: string
    ticketId: string
    applicantUid: string
  }) => {
    const res = await disapproveApplicant(payload)
    return res
  }

  const scanTicketCall = async (payload: {
    eventId: string
    ticketData: { uid: string }
  }) => {
    const res = await scanTicket(payload)
    return res
  }

  return {
    isLoading:
      isGuestListLoading || isInvitedListLoading || isMessageRecordsLoading,
    guestList,
    refetchGuestList,
    refetchMessageRecords,
    messageRecords,
    invitedListData,
    refetchInvitedListData,
    approveApplicantCall,
    disapproveApplicantCall,
    scanTicketCall,
  }
}
